angular.module('app.services').factory('defaultFilterService', [
  'api',
  function(api) {
    let instance = {
      fetchDefaultViewFilter: fetchFilterPayload => {
        return api
          .fetchDefaultViewForUsers(fetchFilterPayload)
          .then(data => {
            if (data.data) {
              return data.data.filterId
            }
          })
          .catch(err => {
            return err
          })
      },
      displayDefaultView: (savedFilters, defaultViewFilter, gridOptions) => {
        gridOptions.api.getFilterModel()
        let filter = savedFilters.filter(x => x.id == defaultViewFilter)
        filter[0].defaultView = true
        filter[0].isApplied = true
        let view = JSON.parse(filter[0].filter)
        if (view.columnState) {
          if (view.columnState.group) {
            gridOptions.columnApi.setColumnState(view.columnState.state)
            gridOptions.columnApi.setColumnGroupState(view.columnState.group)
          } else gridOptions.columnApi.setColumnState(view.columnState)
        }
        if (view.sort) gridOptions.api.setSortModel(view.sort)
        if (view.filter) gridOptions.api.setFilterModel(view.filter)
        if (view.index) gridOptions.api.ensureIndexVisible(view.index, 'middle')
      },
    }

    return instance
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/services/defaultViewFilter.js